// extracted by mini-css-extract-plugin
export default {"cartHeading":"cart_cartHeading__uNFv0","submitBtn":"cart_submitBtn__t8W9Z"};